import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/userTypes'
import Component from 'components/UserTypes'

export default createListViewContainer({ actions, selectors: selectors.userTypes })(Component)
